<template>
  <DDR
      :active="false"
      :draggable="false"
      :rotatable="false"
      :minWidth="item.minWidth"
      :minHeight="item.minHeight"
      :key="item.id"
      :id="item.id"
      :acceptRatio="false"
      :parent="true"
      :axis="'xy'"
      v-model="item.transform"
      :renderContent="renderElementLayer">
  </DDR>
</template>
<script>

import DDR from 'yoyoo-ddr'
import 'yoyoo-ddr/dist/yoyoo-ddr.css'
import 'shaka-player/dist/controls.css';
import {TypeChooseLayer} from '../constant';
import ComponentImpl from "./VideoPlayerComponent.js";
import {TypePlayList} from "../../../ManHinhDienTu-CMS/src/constant";

export default {
  name: 'Draggable',
  components: {DDR},
  props: ['item'],
  data: function () {
    return {
      loading: {value: false},
      typeChooseLayer: TypeChooseLayer,
      items: [],
      singleVideo: null,
    }
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  methods: {
    renderElementLayer() {
      if (this.item.extractData && (this.item.extractData.typeLayer != null && this.item.extractData.typeLayer != undefined)) {
        var item = this.item;
        var attr = item.attr;
        var data = item.extractData;
        var transform = item.transform;
        var _style;
        var _styleWrapper;
        var DynamicComponent;
        switch (this.item.extractData.typeLayer) {
          case this.typeChooseLayer.TEXT : {
            if (this.item.extractData.isRun === true) {     /* Xử lý chữ chạy với loại văn bản */
              _style = `animation: scrollLeft ${attr.speed}s linear infinite;color:${attr.color};font-size:${attr.fontSize}px;font-weight:${attr.fontWeight};letter-spacing:${attr.letterSpacing}px;line-height:${transform.height}px;font-family:${attr.font};font-style:${attr.fontStyle};text-decoration:${attr.textDecoration};`;
              _styleWrapper = `height:${transform.height}px;background:${attr.background}`;
              DynamicComponent = ComponentImpl['textRunPlayer']
              return (
                  <DynamicComponent fileId={data.id} idLayer={item.id} content={data.content}
                                    _styleWrapper={_styleWrapper} _style={_style}/>)
            } else {
              _style = `height:${transform.height}px;color:${attr.color};font-size:${attr.fontSize}px;font-weight:${attr.fontWeight};line-height:${attr.lineHeight}px;
                          background:${attr.background};letter-spacing:${attr.letterSpacing}px;font-family:${attr.font};text-align:${attr.textAlign};font-style:${attr.fontStyle};text-decoration:${attr.textDecoration};`;

              DynamicComponent = ComponentImpl['textNormalPlayer']
              return (
                  <DynamicComponent fileId={data.id} idLayer={item.id} content={data.content} _style={_style}/>)
            }
            break;
          }
          case this.typeChooseLayer.IMAGE : {
            _style = `width:${transform.width}px;height:${transform.height}px`;
            DynamicComponent = ComponentImpl['imageSinglePlayer']
            return (
                <DynamicComponent fileId={data.id} idLayer={item.id} url={data.url} content={data.content}
                                  _style={_style}/>)
            break;
          }
          case this.typeChooseLayer.VIDEO : {
            var posterUrl = '';
            _style = `width:${transform.width}px;height:${transform.height}px`;
            DynamicComponent = ComponentImpl['videoSinglePlayer']
            return (
                <DynamicComponent fileId={data.id} idLayer={item.id} manifestUrl={data.url} posterUrl={data.urlThumbnail}
                                  _style={_style} muted={attr.isMuted}/>)
            break;
          }
          case this.typeChooseLayer.STREAM_VTV : {
            var posterUrl = '';
            _style = `width:${transform.width}px;height:${transform.height}px`;
            DynamicComponent = ComponentImpl['videoSinglePlayer']
            return (
                <DynamicComponent fileId={data.id} idLayer={item.id} manifestUrl={data.url} posterUrl={data.urlThumbnail}
                                  _style={_style} muted={attr.isMuted}/>)
            break;
          }
          case this.typeChooseLayer.PLAY_LIST : {
            _style = `width:${transform.width}px;height:${transform.height}px`;
            if (data.type === TypePlayList.TEXT_RUN) {    /* Playlist loại chữ chạy */
              _style = `animation: scrollLeft ${attr.speed}s linear infinite;color:${attr.color};font-size:${attr.fontSize}px;font-weight:${attr.fontWeight};letter-spacing:${attr.letterSpacing}px;line-height:${transform.height}px;font-family:${attr.font};font-style:${attr.fontStyle};text-decoration:${attr.textDecoration};`;
              _styleWrapper = `height:${transform.height}px;background:${attr.background}`;
              DynamicComponent = ComponentImpl['textRunPlayListPlayer']
              return (
                  <DynamicComponent idLayer={item.id} items={data} _styleWrapper={_styleWrapper}
                                    _style={_style}/>)
            } else if (data.type === TypePlayList.TEXT_NORMAL) { /* PlayList loại Chữ thường */
              _style = `height:${transform.height}px;color:${attr.color};font-size:${attr.fontSize}px;font-weight:${attr.fontWeight};line-height:${attr.lineHeight}px;
                          background:${attr.background};letter-spacing:${attr.letterSpacing}px;font-family:${attr.font};text-align:${attr.textAlign};font-style:${attr.fontStyle};text-decoration:${attr.textDecoration};`;
              DynamicComponent = ComponentImpl['textNormalPlayListPlayer']
              return (<DynamicComponent items={data.playListDetailModels} idLayer={item.id} _style={_style}/>)
            } else if (data.type === TypePlayList.IMAGE) {    /* PlayList loại Hình ảnh */
              _style = `width:${transform.width}px;height:${transform.height}px`;
              DynamicComponent = ComponentImpl['imagePlayListPlayer']
              return (<DynamicComponent items={data.playListDetailModels} idLayer={item.id} _style={_style}/>)
            } else if (data.type === TypePlayList.VIDEO) {  /* PlayList loại Video */
              _style = `width:${transform.width}px;height:${transform.height}px`;
              DynamicComponent = ComponentImpl['videoPlayListPlayer']
              return (<DynamicComponent items={data.playListDetailModels} idLayer={item.id} _style={_style}
                                        muted={attr.isMuted}/>)
            } else if (data.type === TypePlayList.DOCUMENT) {  /* PlayList loại tài liệu */
              _style = `width:${transform.width}px;height:${transform.height}px`;
              DynamicComponent = ComponentImpl['documentPlayListPlayer']
              return (<DynamicComponent items={data.playListDetailModels} idLayer={item.id} _style={_style}
                                        muted={attr.isMuted}/>)
            }
            break;
          }
          case this.typeChooseLayer.YOUTUBE : {
            _style = `width:${transform.width}px;height:${transform.height}px`;
            var urlVideo = `${data.url}?version=3&autoplay=1&loop=1&enablejsapi=1&modestbranding=1&controls=0&mute=${attr.isMuted === true ? 1 : 0}&disablekb=1&rel=0&showinfo=0&iv_load_policy=3&playlist=${data.videoId}`
            DynamicComponent = ComponentImpl['youtubePlayer']
            return (<DynamicComponent idLayer={item.id} videoId={data.videoId} url={urlVideo} width={transform.width}
                                      isMuted={attr.isMuted}
                                      height={transform.height} _style={_style}/>)
            break;
          }
          case this.typeChooseLayer.RSS : {
            _style = `animation: scrollLeft ${attr.speed}s linear infinite;color:${attr.color};font-size:${attr.fontSize}px;font-weight:${attr.fontWeight};letter-spacing:${attr.letterSpacing}px;line-height:${transform.height}px;font-family:${attr.font};font-style:${attr.fontStyle};text-decoration:${attr.textDecoration};`;
            _styleWrapper = `height:${transform.height}px;background:${attr.background}`;
            DynamicComponent = ComponentImpl['rssPlayer']
            return (
                <DynamicComponent fileId={data.id} idLayer={item.id} item={data}
                                  _styleWrapper={_styleWrapper} _style={_style}/>)
            break;
          }
          case this.typeChooseLayer.DOCUMENT : {
            _style = `width:${transform.width}px;height:${transform.height}px`;
            DynamicComponent = ComponentImpl['documentPlayer']
            return (
                <DynamicComponent fileId={data.id} idLayer={item.id} item={data} _style={_style}/>)
          }

          case this.typeChooseLayer.AREA_TEXT : {
            _style = `animation: scrollLeft ${attr.speed}s linear infinite;color:${attr.color};font-size:${attr.fontSize}px;font-weight:${attr.fontWeight};letter-spacing:${attr.letterSpacing}px;line-height:${transform.height}px;font-family:${attr.font};font-style:${attr.fontStyle};text-decoration:${attr.textDecoration};`;
            _styleWrapper = `height:${transform.height}px;background:${attr.background}`;
            DynamicComponent = ComponentImpl['centralPlayer']
            return (
                <DynamicComponent idLayer={item.id} items={data.playListDetailModels} _styleWrapper={_styleWrapper}
                                  muted={attr.isMuted}
                                  _style={_style}/>)
          }
          case (this.typeChooseLayer.AREA_LEFT) : {
            _style = `width:${transform.width}px;height:${transform.height}px`;
            DynamicComponent = ComponentImpl['centralPlayer']
            return (
                <DynamicComponent idLayer={item.id} items={data.playListDetailModels} muted={attr.isMuted}
                                  _style={_style}/>)
          }
          case (this.typeChooseLayer.AREA_RIGHT) : {
            _style = `width:${transform.width}px;height:${transform.height}px`;
            DynamicComponent = ComponentImpl['centralPlayer']
            return (
                <DynamicComponent idLayer={item.id} items={data.playListDetailModels} muted={attr.isMuted}
                                  _style={_style}/>)
          }
          case (this.typeChooseLayer.FULL_SCREEN) : {
            _style = `width:${transform.width}px;height:${transform.height}px`;
            DynamicComponent = ComponentImpl['centralPlayer']
            return (
                <DynamicComponent idLayer={item.id} items={data.playListDetailModels} muted={attr.isMuted}
                                  _style={_style}/>)
          }
        }
      }
    },
  },
  watch: {},
  destroyed() {
  }
}
</script>

<style scoped>
video {
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/views/Draggable.vue